import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';

@Component({
  selector: 'app-online-indicator',
  templateUrl: './online-indicator.component.html',
  styleUrls: ['./online-indicator.component.scss']
})
export class OnlineIndicatorComponent implements OnInit {

  constructor() { }

  @Input()
  size: number;

  @Input()
  color: string = 'red';

  ngOnInit(): void {
  }

}
